// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2aMtK","title":"ClientCherryInfo_title__2IZtC","itemText":"ClientCherryInfo_itemText__1l4Ag"};